// What only the browser needs from formatting a value: relative time and the parsing of what a person types.
// The formatting of stored values lives in the core (@confdeck/core-shared), so the server writes the same text into a file.

import { formatDate } from '@confdeck/core-shared';

/** Relative time for activity: «5 мин назад», «вчера», then a date; a moment ahead — «через 2 ч» (a paused run, Grok review 30.10). */
export function ago(v: string): string {
  const diff = (Date.now() - new Date(v).getTime()) / 1000;
  if (diff < -45) {
    const ahead = -diff;
    if (ahead < 3600) return `через ${Math.max(1, Math.round(ahead / 60))} мин`;
    if (ahead < 86400) return `через ${Math.round(ahead / 3600)} ч`;
    return formatDate(v);
  }
  if (diff < 45) return 'только что';
  if (diff < 3600) return `${Math.round(diff / 60)} мин назад`;
  if (diff < 86400) return `${Math.round(diff / 3600)} ч назад`;
  if (diff < 172800) return 'вчера';
  return formatDate(v);
}

/** Parses what a person types into a money cell: «150 000», «150к», «1,5 млн» → kopecks. */
export function parseMoney(input: string): number | null {
  const s = input.toLowerCase().replace(/\s|₽|руб\.?/g, '').replace(',', '.');
  if (!s) return null;
  const m = s.match(/^(-?\d+(?:\.\d+)?)(к|k|тыс|млн|m)?$/);
  if (!m) return NaN;
  const mult = m[2] === 'к' || m[2] === 'k' || m[2] === 'тыс' ? 1e3 : m[2] === 'млн' || m[2] === 'm' ? 1e6 : 1;
  return Math.round(Number(m[1]) * mult * 100);
}

/** Phone input to E.164: «8 (999) 123-45-67» → «+79991234567». */
export function normalizePhone(input: string): string {
  const d = input.replace(/\D/g, '');
  if (d.length === 11 && d.startsWith('8')) return `+7${d.slice(1)}`;
  if (d.length === 10) return `+7${d}`;
  return d ? `+${d}` : '';
}
